<template>
    <div class="position-list-box" >
        <div class="position-info" @click="goToDetail">
            <a class="flex-box">
                <h2 class="pos-title line-clamp" >
                    <span v-html="position.positionTitle"></span>
                    <!-- <span class="icon-tag tag-price-lie">猎享付</span> -->
                    <b class="red-circle" v-if="!position.isRead && name == 'pa'"></b>
                </h2>
                <span class="salary" v-if="position.annualSalaryDesc">{{position.annualSalaryDesc}}万</span>
            </a>
            <div class="flex-box mtb10 rel">
                <div class="separate-info-list">
                    <span class="cities" v-if="allCities && allCities.length">{{allCities.join(',')}}</span>
                    <span v-if="position.degreeRequiredStr">{{position.degreeRequiredStr}}</span>
                    <span v-if="position.workExpYearDesc">{{position.workExpYearDesc}}</span>
                    <span v-if="position.headCount">{{position.headCount}}人</span>
                </div>
                <div class="feedback-tips abs" v-if="type != 'share'">
                    <span v-if="position.recommendFeedbackTime">{{position.recommendFeedbackTime | withdrawFeedbackTime}}反馈</span>
                    <span v-else>3天反馈</span>
                </div>
            </div>
            <div class="flex-box">
                <position-tags class="tag-list" :position="position" v-if="position.positionTags && position.positionTags.length"></position-tags>
                <div class="btn-wrap" v-if="position.statics && (position.statics.aiTalentsTotal || position.statics.homoPosition)">
                    <span class="btn-color-wrap btn-color-blue" v-if="position.statics&&position.statics.aiTalentsTotal">
                      <a class="btn-color" href="javascript:;">AI人岗匹配<span class="num">({{position.statics.aiTalentsTotal}})</span></a>
                    </span>
                    <span class="btn-color-wrap btn-color-purple" v-if="position.statics&&position.statics.homoPosition">
                      <a class="btn-color" href="javascript:;">相似职位<span class="num">({{position.statics.homoPosition}})</span></a>
                    </span>
                </div>
            </div>
        </div>
        <company class="company-wrap" :company="position.enterprise" :position="position"  v-if="type!='companyDetail'"></company>
    </div>
</template>

<script>
  import PositionTags from "./positionTags";
  import Company from "../company/company";
  import {firstReadPositionBag} from '@/api/pa'

  export default {
    components: { Company, PositionTags },
    data(){
        return {
            name: this.$route.name ,
            allCities:[]
        }
    },
    props: {
        position: {},
        type: {}
    },
    methods: {
        getLocations(){
            let locations = this.position.locations || [];
            locations.forEach((cols, index) => {
                this.allCities.push(cols.workCityName);
            });
        },
        goToDetail(){

            // if(this.position.positionBagId){
            //     firstReadPositionBag({positionBagId: this.position.positionBagId}).then(res=>{
                    
            //     }).catch(err=>{})
            // }

            let params = {};
            if(this.position.positionBagId){
                params.positionBagId = this.position.positionBagId;
            }

            // this.$router.push(`/positions/detail/${this.position.positionId}`);

            this.$router.push({name: 'detail', params: {positionId: this.position.positionId}, query: {...params}});
        }
    },
    created(){
        
        this.getLocations();
    },
    watch: {
       
    }
  };
</script>

<style scoped lang="scss">
    .position-list-box {
        background-color: #fff;
        margin-bottom: 10px;
        padding: 15px;
        .position-info {
            overflow: hidden;
            .pos-title {
                font-size: 16px;
                margin-right: 20px;
                color: #333;
                position: relative;
                .red-circle{
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    position: absolute;
                    background: #FA3E25;
                    top: 0;
                    right: 0;
                }
                &:hover,&:active,&:visited{
                    color: #22BAA5;
                }
            }
            .separate-info-list{
                .cities {
                    max-width: 60px;
                }
                // span:first-child{
                //     // overflow: visible;
                // }
            }
            .salary {
                font-size: 16px;
                color: #FF6E00;
                text-align: right;
                white-space: nowrap;
                margin-left: auto;
                align-self: flex-start;
            }

            .feedback-tips {
                margin-left: auto;
                font-size: 10px;
                padding: 3px 6px;
                background-color: #f0f0f0;
                border-radius: 4px;
                right: 0;
            }
            .tag-list {
                margin: 0;
            }
            .btn-wrap{
                display: flex;
                margin-left: 5px;
                .btn-color-wrap{
                    margin-left: 5px;
                }
            }
        }
        .company-wrap{
            margin-top: 5px;
            padding-bottom: 0;
        }
    }
</style>
